export const statusOptions = [
  { value: 'pending', label: 'Pendente' },
  { value: 'active', label: 'Ativo' },
  { value: 'denied', label: 'Negado' },
  { value: 'contract_pending', label: 'Contrato pendente' },
];
